import { CmsApiSplitContentBlockData } from 'modules/cms/api/types/CmsApiSplitContent';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsAmpSplitContentBlock } from 'modules/cms/blocks/Amp/CmsAmpSplitContentBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsSplitContentBlock } from './CmsSplitContentBlock';

export const CmsSplitContentBlockMapping: CmsBlockMapping<CmsApiSplitContentBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsSplitContentBlock,
    AmpComponent: CmsAmpSplitContentBlock,
  };
